// src/pages/TestMolliePayment.jsx
// ⚠️ COMPOSANT TEMPORAIRE — à supprimer une fois le test validé.
import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../firebase';

export default function TestMolliePayment() {
  const [status, setStatus] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const testPayment = async () => {
    setStatus('loading');
    setError('');
    setResult(null);

    try {
      const functions = getFunctions(app, 'europe-west1');
      const createPayment = httpsCallable(functions, 'createPayment');

      const response = await createPayment({
        type: 'registration',
        refId: 'dhSVi1cr2JMsGab8p9tM',
        amount: 1.0, // 1€ pour le test
        description: 'Test Mollie MKD Studio'
      });

      setResult(response.data);
      setStatus('success');

      // Ouvre le checkout Mollie dans un nouvel onglet
      window.open(response.data.checkoutUrl, '_blank');
    } catch (err) {
      console.error('Erreur test paiement Mollie:', err);
      setError(err.message || 'Erreur inconnue');
      setStatus('error');
    }
  };

  return (
    <div style={{ padding: '2rem', maxWidth: 600, margin: '0 auto' }}>
      <h2>🧪 Test Mollie — createPayment</h2>
      <p>
        Ce bouton appelle <code>createPayment</code> avec le document de test{' '}
        <code>dhSVi1cr2JMsGab8p9tM</code> (collection <code>registrations</code>) pour un
        montant de 1€.
      </p>

      <button
        onClick={testPayment}
        disabled={status === 'loading'}
        style={{
          padding: '12px 24px',
          fontSize: '16px',
          backgroundColor: '#000',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          cursor: status === 'loading' ? 'not-allowed' : 'pointer'
        }}
      >
        {status === 'loading' ? 'Création du paiement...' : 'Lancer le test Mollie (1€)'}
      </button>

      {status === 'success' && result && (
        <div style={{ marginTop: '1.5rem', padding: '1rem', background: '#e6f7e6', borderRadius: '8px' }}>
          <p>✅ Paiement créé avec succès.</p>
          <p>
            <strong>ID paiement Firestore :</strong> {result.paymentId}
          </p>
          <p>
            <strong>URL checkout :</strong>{' '}
            <a href={result.checkoutUrl} target="_blank" rel="noreferrer">
              {result.checkoutUrl}
            </a>
          </p>
          <p style={{ marginTop: '0.5rem' }}>
            Un nouvel onglet a dû s'ouvrir sur le checkout Mollie. Choisissez le statut{' '}
            <strong>"Payé"</strong> dans la simulation de mode test.
          </p>
        </div>
      )}

      {status === 'error' && (
        <div style={{ marginTop: '1.5rem', padding: '1rem', background: '#fde6e6', borderRadius: '8px' }}>
          <p>❌ Erreur : {error}</p>
        </div>
      )}
    </div>
  );
}
